/**
 * Utility to dynamically update meta tags for SEO
 * This helps with Open Graph, Twitter Cards, and general meta information
 */

export const updateMetaTags = (config = {}) => {
  const {
    title = 'Vedamarga - Online Pooja Booking & Ritual Services',
    description = 'Book authentic Vedic rituals, pujas, and ceremonies online. Expert pooja services including Grahshanti, Yagna, Havan, and astrology consultations.',
    keywords = 'pooja booking, puja, rituals, vedic ceremonies, havan, yagna, grahshanti, astrology, online pooja, hindu rituals, vedamarga',
    image = '/og-image.jpg',
    url = 'https://vedamarga.com/',
    type = 'website',
  } = config;

  // Update title
  document.title = title;

  // Update meta description
  updateMetaTag('description', description);
  updateMetaTag('keywords', keywords);

  // Update Open Graph tags
  updateMetaTag('og:title', title, 'property');
  updateMetaTag('og:description', description, 'property');
  updateMetaTag('og:image', image, 'property');
  updateMetaTag('og:url', url, 'property');
  updateMetaTag('og:type', type, 'property');

  // Update Twitter Card tags
  updateMetaTag('twitter:title', title, 'property');
  updateMetaTag('twitter:description', description, 'property');
  updateMetaTag('twitter:image', image, 'property');
  updateMetaTag('twitter:card', 'summary_large_image', 'property');

  // Update canonical link
  updateCanonicalLink(url);
};

const updateMetaTag = (name, content, attrType = 'name') => {
  let element = document.querySelector(`meta[${attrType}="${name}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrType, name);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const updateCanonicalLink = (url) => {
  let link = document.querySelector('link[rel="canonical"]');

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }

  link.setAttribute('href', url);
};

// Page-specific meta configurations
export const pageMetaConfig = {
  home: {
    title: 'Vedamarga - Online Pooja Booking & Ritual Services',
    description: 'Book authentic Vedic rituals, pujas, and ceremonies online. Vedamarga offers expert pooja services. Easy online booking for all Hindu rituals.',
    keywords: 'pooja booking, puja, rituals, vedic ceremonies, havan, yagna, online pooja, hindu rituals, vedamarga',
    url: 'https://vedamarga.com/',
  },
  about: {
    title: 'About Vedamarga - Online Pooja & Ritual Services',
    description: 'Learn about Vedamarga and our mission to preserve authentic Vedic traditions through accessible online pooja booking and ritual services.',
    keywords: 'about vedamarga, vedic traditions, pooja services, ritual expertise',
    url: 'https://vedamarga.com/about',
  },
  poojaDetails: {
    title: 'Pooja Booking Details - Vedamarga',
    description: 'Book your preferred Vedic puja and ritual ceremony. Comprehensive details about our various pooja services with expert priests and authentic methods.',
    keywords: 'pooja booking, puja details, vedic rituals, book pooja online, ritual services',
    url: 'https://vedamarga.com/pooja-details',
  },
  astrology: {
    title: 'Astrology Services - Vedamarga',
    description: 'Get personalized astrology consultations from expert astrologers. Vedamarga offers detailed horoscope readings and astrological guidance.',
    keywords: 'astrology, horoscope, astrological consultation, vedic astrology, birth chart analysis',
    url: 'https://vedamarga.com/astrology',
  },
  cart: {
    title: 'Shopping Cart - Vedamarga',
    description: 'Complete your pooja booking. Secure checkout for your selected Vedic rituals and ceremonies.',
    keywords: 'pooja cart, booking checkout, vedic rituals, puja services',
    url: 'https://vedamarga.com/cart',
  },
  myBookings: {
    title: 'My Bookings - Vedamarga',
    description: 'View and manage your pooja bookings on Vedamarga. Track your ritual service schedules and history.',
    keywords: 'my bookings, booking history, pooja bookings, ritual services',
    url: 'https://vedamarga.com/my-bookings',
  },
  profile: {
    title: 'My Profile - Vedamarga',
    description: 'Manage your Vedamarga account profile and preferences.',
    keywords: 'profile, account settings, vedamarga account',
    url: 'https://vedamarga.com/profile',
  },
};
